import React, { Fragment } from 'react';
import '../../static/InvalidUrl.css';
import { Button } from 'react-materialize';
import { Link } from 'react-router-dom';
import LandingFooter from '../landing/LandingFooter';
import { FormattedMessage } from 'react-intl';

const InvalidUrl = props => (
	<Fragment>
		<div className='invalid-url-container'>
			<div>
				<h1>
					<FormattedMessage
						id="invalid_url.page_not_found"
						defaultMessage={`Sorry we couldn't find that page`}
					/>
				</h1>
			</div>
			<div>
				<Link to='/home'>
					<Button>
						<FormattedMessage
							id="invalid_url.button.home"
							defaultMessage={`Go Home`}
						/>
					</Button>
				</Link>
			</div>
		</div>
		<LandingFooter />
	</Fragment>
);

export default InvalidUrl;


// WEBPACK FOOTER //
// ./src/components/global/InvalidUrl.js